import * as React from 'react';
import cn from 'clsx';

import * as styles from './styles.css';

export interface ILinkProps {
  text: string;
  href?: string;
  multiLine?: boolean;

  onClick?(): void;
}

export const Link: React.FC<ILinkProps> = props => {
  const { onClick, text, href, multiLine } = props;

  return (
    <a
      className={cn(styles['link'], { [styles['multiline']]: multiLine })}
      data-testid="agreement-link"
      onClick={onClick}
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {text}
    </a>
  );
};

Link.displayName = 'Link';
